import { APIResponse, useAppQuery, UserRoleIDEnum } from '@alluradirect/react';

export const useTermsOfServiceHTMLQuery = ({
  user_type_id,
  is_direct_vacations = false,
}: {
  user_type_id: UserRoleIDEnum;
  is_direct_vacations?: boolean;
}) => {
  return useAppQuery<APIResponse<{ TOSSA: string }>>({
    endpoint: '/RESTAUTH/tossa/?' + `user_type_id=${user_type_id}&is_direct_vacations=${is_direct_vacations}`,
  });
};
